import { Card, Stack, Text } from '@tiendanube/components';
import useTranslationOrders from 'domains/Orders/useTranslationOrders/useTranslationOrders';

function BillingAddressCardSkeleton() {
  const t = useTranslationOrders();

  return (
    <Card title={t('abandonedCarts.billingAddressCard.title')} isCollapsible>
      <Stack column align="flex-start" spacing="tight">
        <Text.Skeleton width="large" />
        <Text.Skeleton size="caption" />
        <Text.Skeleton width="large" />
      </Stack>
    </Card>
  );
}

export default BillingAddressCardSkeleton;
